<template>
  <base-card>
    <base-question :text="'Informe a disponibilidade ' + name" />

    <base-radio
      label="Sempre disponível"
      :family="id"
      v-model="visible"
      :option="'always'"
      class="mb_15"
    />
    <base-radio
      label="Disponível em horários específicos"
      :family="id"
      v-model="visible"
      :option="'times'"
      class="mb_5"
    />

    <div v-if="visible === 'times'" class="visible-times">
      <p class="text-title mb_10">Dias da semana</p>
      <div class="d-flex mb_25">
        <div :class="isSelected(1)" @click.prevent="changeWeekDay(1)">D</div>
        <div :class="isSelected(2)" @click.prevent="changeWeekDay(2)">S</div>
        <div :class="isSelected(4)" @click.prevent="changeWeekDay(4)">T</div>
        <div :class="isSelected(8)" @click.prevent="changeWeekDay(8)">Q</div>
        <div :class="isSelected(16)" @click.prevent="changeWeekDay(16)">Q</div>
        <div :class="isSelected(32)" @click.prevent="changeWeekDay(32)">S</div>
        <div :class="isSelected(64)" @click.prevent="changeWeekDay(64)">S</div>
      </div>

      <div class="row half-cols">
        <div :class="deleteMode ? 'col-xs-5' : 'col-xs-6'">
          <p class="text-title">Inicio do período</p>
        </div>
        <div :class="deleteMode ? 'col-xs-5' : 'col-xs-6'">
          <p class="text-title">Fim do período</p>
        </div>
        <div
          v-if="deleteMode && availability.periods.length > 1"
          class="col-xs-2"
        >
          <p class="text-title">Excluir</p>
        </div>
      </div>

      <div v-if="availability && availability.periods.length > 0">
        <div
          class="row half-cols"
          v-for="(period, periodIndex) in availability.periods"
          :key="periodIndex"
        >
          <div :class="deleteMode ? 'col-xs-5' : 'col-xs-6'">
            <base-input
              placeholder="00:00"
              class="mb_0"
              v-model="period.beginTime"
              :masked="true"
              :mask="StringLanguage.timeMask"
              type="tel"
              :valid="period.beginTimeIsValid"
              @input="handleInput"
              @focus="
                () => {
                  period.beginTimeIsValid = true;
                }
              "
              @blur="(e) => validateTime(e, period, 'beginTime')"
            />
          </div>
          <div :class="deleteMode ? 'col-xs-5' : 'col-xs-6'">
            <base-input
              placeholder="00:00"
              class="mb_0"
              v-model="period.endTime"
              :masked="true"
              :mask="StringLanguage.timeMask"
              type="tel"
              :valid="period.endTimeIsValid"
              @input="handleInput"
              @focus="
                () => {
                  period.endTimeIsValid = true;
                }
              "
              @blur="(e) => validateTime(e, period, 'endTime')"
            />
          </div>
          <div
            v-if="deleteMode && availability.periods.length > 1"
            class="col-xs-2"
          >
            <base-button
              design="four"
              class="w-100 mt_10 icon"
              @click.prevent="deletePeriod(periodIndex)"
            >
              <i class="fal fa-trash-alt"></i>
            </base-button>
          </div>
        </div>
      </div>

      <div class="row mt_10" :class="{'half-cols': !deleteMode && availability.periods.length > 1}">
        <div :class="!!deleteMode ? 'd-none' : availability.periods.length > 1 ? 'col-xs-6' : 'col-xs-12'">
          <base-button
            v-if="!deleteMode"
            :text="'Adicionar período'"
            @click.prevent="addPeriod()"
            design="two"
            class="w-100"
          />
        </div>
        <div :class="!!deleteMode ? 'col-xs-12' : 'col-xs-6'">
          <base-button
            v-if="
              (availability && availability.periods.length > 1) || deleteMode
            "
            @click.prevent="deleteMode = !deleteMode"
            :text="deleteMode ? StringLanguage.back : 'Remover período'"
            design="four"
            class="w-100"
          />
        </div>
      </div>
    </div>
  </base-card>
</template>

<script>
import BaseCard from "@/components/Card";
import BaseRadio from "@/components/Radio";
import BaseQuestion from "@/components/Question";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";

export default {
  components: {
    BaseCard,
    BaseRadio,
    BaseQuestion,
    BaseInput,
    BaseButton,
  },

  props: {
    name: { type: String, default: "produto" },
    availability: { type: Object },
  },
  data() {
    return {
      visible: !this.availability ? 'always' : 'times',
      deleteMode: false,
      id: "",
    };
  },
  watch: {
    availability: {
      deep: true,
      handler(newV) {
        if (!!newV) {
          this.visible = "times";
        } else {
          this.visible = "always";
        }

        this.$emit("updateModel", this.targetItem);
      },
    },
    visible: {
      deep: true,
      handler(newV) {
        if (newV === "always") {
          return this.$emit("updateAvailability", null);
        }

        if (!this.availability || !this.availability.periods.length)
          this.initPeriod();
      },
    },
  },
  methods: {
    deleteItem(elm) {
      this.$emit("removeElement", elm);
      return false;
    },
    toggleDeleteMode(activate) {
      this.$emit("deleteMode", activate);
    },

    isSelected(weekDay) {
      let daysOfTheWeek = this.availability
        ? this.availability.daysOfTheWeek
        : 0;

      return (daysOfTheWeek & weekDay) == weekDay
        ? "week-day-icon selected"
        : "week-day-icon";
    },
    changeWeekDay(weekDay) {
      let daysOfTheWeek = this.availability
        ? this.availability.daysOfTheWeek
        : 0;

      /* se já está marcado, remove. Caso contrário adiciona */
      let newDaysOfTheWeek = 0;
      if ((daysOfTheWeek & weekDay) == weekDay) {
        newDaysOfTheWeek = daysOfTheWeek - weekDay;
      } else {
        newDaysOfTheWeek = daysOfTheWeek + weekDay;
      }

      const newAvailability = {
        daysOfTheWeek: newDaysOfTheWeek,
        periods:
          this.availability && this.availability.periods
            ? this.availability.periods
            : [],
      };

      this.$emit("updateAvailability", newAvailability);
    },
    validateTime(e, vModel, key) {
      let [hours, minutes] = vModel[key]
        .replace(":", "")
        .padEnd(4, "0")
        .match(/.{1,2}/g);
      let date = new Date(0, 0, 0, hours, minutes);
      if (hours != date.getHours() || minutes != date.getMinutes()) {
        vModel[key] = "0000";
      } else {
        vModel[key] = `${hours}${minutes}`;
      }

      if (!vModel[key]) {
        vModel[key + "TimeIsValid"] = false;
      }
    },
    handleInput(_, event) {
      if (event.isTrusted) {
        // Obtem a posição do cursor no input
        let position = event.target.selectionStart;

        // Verifica se vai haver adição da máscara ao input
        if (StringLanguage.timeMask[position - 1] === ":" && event.data) {
          position++;
        }

        // Atualiza a posição do cursor no input
        this.$nextTick(() => {
          setTimeout(() => {
            event.target.setSelectionRange(position, position);
          }, 3);
        });
      }
    },
    initPeriod() {
      const newPeriod = { beginTime: null, endTime: null };
      const newAvailability = {
        daysOfTheWeek:
          this.availability && this.availability.daysOfTheWeek
            ? this.availability.daysOfTheWeek
            : 0,
        periods:
          this.availability && this.availability.periods
            ? [...this.availability.periods, newPeriod]
            : [newPeriod],
      };

      this.$emit("updateAvailability", newAvailability);
    },
    addPeriod() {
      if (this.availability && this.availability.periods.length) {
        const lastPeriod = this.availability.periods.slice(-1)[0];

        if (!lastPeriod.beginTime || !lastPeriod.endTime) {
          alert(StringLanguage.errorAddTime);
          return false;
        }
      }

      this.initPeriod();
    },
    deletePeriod(index) {
      const newAvailability = {
        daysOfTheWeek:
          this.availability && this.availability.daysOfTheWeek
            ? this.availability.daysOfTheWeek
            : 0,
        periods: this.availability.periods.filter((period, i) => i !== index),
      };

      if (newAvailability.periods.length == 1) this.deleteMode = false;

      this.$emit("updateAvailability", newAvailability);
    },
  },
  created() {
    // Gerando ID único
    this.id =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
  },
};
</script>
<style scoped>
.row.half-cols > *:not(:last-child) {
  padding-right: 7.5px;
}
.row.half-cols > *:not(:first-child) {
  padding-left: 7.5px;
}
.text-title {
  font-size: 1.2em;
  color: var(--label-primary);
}
.visible-times {
  margin-top: 40px;
}

.week-day-icon {
  font-size: 1.2em;
  width: 29px;
  height: 29px;
  color: var(--label-primary);
  border: 1px solid #8C8C8C;
  border-radius: 3px;
  margin-right: 10px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.week-day-icon.selected {
  color: white;
  border-color: var(--default);
  background: var(--default);
}
</style>